import { classnames } from '@/helpers';
import css from './Icon.module.scss';
import { IconProps, IconVariant } from './types';

const getImageNameWithCacheBreaker = (variant: IconVariant) => {
  switch (variant) {
    case 'phone':
      return 'phone2';
    default:
      return variant;
  }
};

const Icon = ({ variant, color = 'black-900', className = '', size, noFilter = false, ...props }: IconProps) => {
  return (
    <img
      src={`/images/icons/${getImageNameWithCacheBreaker(variant)}.svg`}
      {...props}
      className={classnames(noFilter ? '' : `${css.icon} ${css[color]}`, size && `${css.icon} ${css[size]}`, className)}
      alt={props.alt ?? ''}
    />
  );
};

export default Icon;
